import { C } from '../lib/theme';
import { fmtDate } from '../lib/util';
import { DeadlineIndicator } from './DeadlineIndicator';
import type { Case } from '../domain/initial-cases';

interface VettingSlaCellProps {
  c: Pick<Case, 'decision' | 'decisionDate' | 'slaDeadline'>;
  now: string;
}

// #784 — the vetting SLA as one cell, for the list surfaces (Dashboard Recent
// Cases, the Cases `sla` column). sla_deadline persists after the decision
// (#137), so passing it straight to DeadlineIndicator kept a decided case
// counting down as if it were pending work. Gated on `decision`, not `status`:
// a case under APPEAL or CURE that was decided still met or missed its SLA,
// which is also how the Overview tab and the API's sla-scan read it.
export function VettingSlaCell({ c, now }: VettingSlaCellProps) {
  if (c.decision) {
    // A deleted case was not decided on its merits; it has no SLA outcome.
    if (c.decision === 'DELETED') return <span style={{ color: C.textDim }}>—</span>;
    // Same comparison as OverviewTab: met if the decision landed on or before
    // the deadline, missed otherwise.
    const missed = !!(c.slaDeadline && c.decisionDate && new Date(c.decisionDate) > new Date(c.slaDeadline));
    return (
      <span style={{ fontSize: 12, color: missed ? C.danger : C.success }}>
        {missed ? `✗ SLA missed (${fmtDate(c.decisionDate)})` : `✓ Decided ${fmtDate(c.decisionDate)}`}
      </span>
    );
  }
  if (!c.slaDeadline) return <span style={{ color: C.textDim }}>—</span>;
  return <DeadlineIndicator deadline={c.slaDeadline} label="SLA" now={now} />;
}
